export default "__VITE_ASSET__c10dfcc9__"